import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { LANGUAGES } from "../i18n/languages";

const LocaleSync = () => {
  const { lang, setLanguage, ready } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const seg = location.pathname.split("/")[1] || "";
  const isHelp = seg === "help" || location.pathname.split("/")[2] === "help";
  const urlLang = LANGUAGES.some((l) => l.code === seg) ? seg : null;
  const prev = useRef({ lang, seg });

  useEffect(() => {
    const p = prev.current;
    if (seg !== p.seg && urlLang && urlLang !== lang) {
      setLanguage(urlLang);
    } else if (lang !== p.lang && lang && urlLang !== lang) {
      navigate(isHelp ? `/${lang}/help` : `/${lang}`, { replace: true });
    } else if (!urlLang && ready && lang) {
      const target = isHelp ? `/${lang}/help` : `/${lang}`;
      if (location.pathname !== target) navigate(target, { replace: true });
    }
    prev.current = { lang, seg };
  }, [seg, urlLang, lang, ready, isHelp, location.pathname, navigate, setLanguage]);

  return null;
};

export default LocaleSync;
